"use client";
import { GroupLabelContext } from "./group-label-context.js";
import { createElement, createHook, forwardRef, useWrapElement } from "@ariakit/react-utils";
import { removeUndefinedValues } from "@ariakit/utils";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/group/group.tsx
const TagName = "div";
/**
* Returns props to create a `Group` component.
* @see https://ariakit.com/components/group
* @example
* ```jsx
* const props = useGroup();
* <Role {...props}>Group</Role>
* ```
*/
const useGroup = createHook(function useGroup(props) {
	const [labelId, setLabelId] = useState();
	props = useWrapElement(props, (element) => /* @__PURE__ */ jsx(GroupLabelContext.Provider, {
		value: setLabelId,
		children: element
	}), []);
	props = {
		role: "group",
		"aria-labelledby": props["aria-label"] != null ? void 0 : labelId,
		...props
	};
	return removeUndefinedValues(props);
});
/**
* Renders a group element. Optionally, a
* [`GroupLabel`](https://ariakit.com/reference/group-label) can be rendered as
* a child to provide a label for the group.
* @see https://ariakit.com/components/group
* @example
* ```jsx
* <Group>Group</Group>
* ```
*/
const Group = forwardRef(function Group(props) {
	return createElement(TagName, useGroup(props));
});
//#endregion
export { Group, useGroup };

//# sourceMappingURL=group.js.map